import { useCallback } from 'react';
import type { ListViewMode } from '@/lib/api/requests/ui-preferences';
import { useUiPreferences } from './queries';
import { useUpdateUiPreferences } from './mutations';

/**
 * Whether the Menu Items list shows as a table or as tiles, remembered on the
 * server per user so it follows them between devices. The table is the answer
 * while the preference loads and if it cannot be read.
 */
export function useMenuItemsViewMode(enabled = true): {
  viewMode: ListViewMode;
  setViewMode: (mode: ListViewMode) => void;
} {
  const { data } = useUiPreferences(enabled);
  const { mutate } = useUpdateUiPreferences();

  const viewMode: ListViewMode = data?.menuItemsViewMode === 'tile' ? 'tile' : 'table';

  const setViewMode = useCallback(
    (mode: ListViewMode) => mutate({ menuItemsViewMode: mode }),
    [mutate],
  );

  return { viewMode, setViewMode };
}
